export default "__VITE_ASSET__DgoRCRq2__"